<template>
  <div class="activityPositiveReport">
    <reportPageTemp
      ref="reportPageTemp"
      :reportParams="reportParams"
      :filter="filter"
    >
      <div class="flex-wrap">
        <div class="flex-al mb10 mr10">
          <div class="time-box flex-al fs14" style="width: 260px">
            <el-date-picker
              v-model="rangeTime"
              @change="search"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              style="width: 260px"
            ></el-date-picker>
          </div>
        </div>
        <div class="flex-al mb10 mr10">
          <div class="select-box flex-al">
            <el-select
              v-model="filter.coursetype_id"
              clearable
              filterable
              :placeholder="
                $t('views.Analysisreport.admTrackReport.51yzwntm4j40')
              "
              @change="filterCourseCat"
            >
              <el-option
                v-for="(item, index) in coursetypeList"
                :key="index"
                :label="`${item.coursetype_cnname}(${item.coursetype_branch})`"
                :value="item.coursetype_id"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="flex-al mb10 mr10">
          <div class="select-box" style="width: 170px">
            <el-select
              v-model="filter.coursecat_id"
              clearable
              filterable
              :placeholder="$t('Customersmanage.dac')"
              @change="search"
            >
              <el-option
                v-for="(item, index) in filterList.courseCatList"
                :key="index"
                :label="`${item.coursecat_cnname}(${item.coursecat_branch})`"
                :value="item.coursecat_id"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="flex-al mb10 mr10">
          <div class="select-box flex-al">
            <el-select
              filterable
              clearable
              style="width: 180px"
              @change="(filter.channel_id = ''), getChannelData(), search()"
              v-model="filter.client_source"
              :placeholder="$t('Analysisreport.bd')"
            >
              <el-option
                v-for="item in SchoolsourceOption"
                :key="item.frommedia_id"
                :label="item.frommedia_name"
                :value="item.frommedia_name"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="flex-al mb10 mr10">
          <div class="select-box flex-al">
            <el-select
              filterable
              clearable
              style="width: 180px"
              @change="search"
              v-model="filter.channel_id"
              :placeholder="$t('Analysisreport.be')"
            >
              <!-- <el-option :label="$t('Common.options')" value></el-option> -->
              <el-option
                v-for="item in ChannelOption"
                :key="item.channel_id"
                :label="item.channel_name"
                :value="item.channel_id"
              ></el-option>
            </el-select>
          </div>
        </div>
      </div>
    </reportPageTemp>
  </div>
</template>
<script>
import http from "../analysisreport";
import reportPageTemp from "@/components/report/tableTemplate";
export default {
  name: "analysisreport-activityPositiveReport",
  data() {
    return {
      reportParams: {
        wayString: "activityPositiveReport", //传递到子组件的方法名称
        Title: "活动业绩统计报表",
      },

      rangeTime: [],
      SchoolsourceOption: [],
      ChannelOption: [], // 招生渠道明细
      coursetypeList: [],

      filterList: {
        courseCatList: [],
      },
      // 表格筛选
      filter: {
        starttime: "",
        endtime: "",
        client_source: "",
        channel_id: "",
        coursetype_id: "",
        coursecat_id: "",
      },
    };
  },
  components: {
    reportPageTemp,
  },
  created() {
    this.rangeTime = [
      this.$Common.getAppointedDate(2, 0).startDate,
      this.$Common.getAppointedDate(2, 0).endDate,
    ];
    this.filter.starttime = this.$Common.getAppointedDate(2, 0).startDate;
    this.filter.endtime = this.$Common.getAppointedDate(2, 0).endDate;

    this.courseTypeRecruitApi();
    this.getTypeCourseCatApi();
    this.getSourceData();
    this.getChannelData();
  },
  mounted() {},
  methods: {
    search() {
      this.filter.starttime = this.rangeTime ? this.rangeTime[0] : "";
      this.filter.endtime = this.rangeTime ? this.rangeTime[1] : "";
      this.$refs.reportPageTemp.search();
    },
    courseTypeRecruitApi() {
      this.$http
        .courseTypeRecruitApi({
          coursetype_isrecruit: 1,
        })
        .then((res) => {
          if (res.data.code === 200) {
            this.coursetypeList = res.data.data.list;
          } else {
            this.coursetypeList = [];
          }
        });
    },
    filterCourseCat() {
      this.filter.coursecat_id = "";
      this.getTypeCourseCatApi();
      this.search();
    },
    getTypeCourseCatApi() {
      this.$http
        .getTypeCourseCatApi({
          coursetype_id: this.filter.coursetype_id,
        })
        .then((res) => {
          const { code, data: _jb } = res.data;

          const data = _jb;
          if (code === 200) {
            this.filterList.courseCatList = data.list;
          } else {
            this.filterList.courseCatList = [];
          }
        });
    },
    //获取招生渠道类型
    getSourceData() {
      http.getSource({}).then((res) => {
        this.SchoolsourceOption = res.data.data.list;
      });
    },
    //获取招生渠道明细
    getChannelData() {
      http
        .getChannel({
          channel_medianame: this.filter.client_source,
        })
        .then((res) => {
          this.ChannelOption = res.data.data.list;
        });
    },
  },
};
</script>
<style lang="less">
@import url("../../../assets/less/manage.less");
@import url("../analysisreport.less");
.activityPositiveReport {
  // height: 100vh;
  font-size: 20px;
}
</style>
